module.exports = __webpack_public_path__ + "static/media/Vlogo.9fa42eca.png";